import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-seq-detail-edit",
  "use": "icon-seq-detail-edit-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-seq-detail-edit\">\n<path d=\"M12.5 5.00007L15 7.50007M10.8333 16.6667H17.5M4.16665 13.3334L3.33331 16.6667L6.66665 15.8334L16.3216 6.17841C16.6341 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.6341 4.13429 16.3216 3.82174L16.1783 3.67841C15.8658 3.36596 15.4419 3.19043 15 3.19043C14.558 3.19043 14.1342 3.36596 13.8216 3.67841L4.16665 13.3334Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol